import React from 'react'
import CountriesState from './Charts/CountriesState'
import Doughnut from './Charts/Doughnut'
import "./style.css"
import TotalAssets from './Charts/totalAssets'
import SalesStats from './Charts/SalesStats'
import HeaderName from '../../component/HeaderName'
import { useTranslation } from 'react-i18next'
const ColorPallete = [{ id: 1, color: '#FE4D22' }, { id: 2, color: '#FFE14D' }, { id: 3, color: '#FF9A35' }, { id: 4, color: '#98A2B2' }, { id: 5, color: "#4E4E4E" }]

const HomePage = () => {

    const { t } = useTranslation()

    return (

        <>
            <HeaderName PageName={t("Home")} />
        </>
    )
}

export default HomePage